export default __webpack_public_path__ + "static/media/person-5.f760ef71.svg";